"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var context_1 = require("./context");
var theme_1 = require("../../utils/theme");
var Container = (function (_super) {
    tslib_1.__extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children;
            var cls = classNames(prefixCls, className);
            return (h("div", { className: cls, style: tslib_1.__assign({ position: 'relative' }, style), ref: _this.ref },
                h(context_1.ContainerContext.Provider, { value: _this.ref.current }, children)));
        };
        return _this;
    }
    Container.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    Container.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Container;
}(React.Component));
exports.default = Container;
Container.defaultProps = {
    prefixCls: 'dui-snackbar-container',
};
Container.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
};
